var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTeamMembers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3 User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M72.3374 56.9876C76.8653 58.2315 81.7326 55.991 83.6568 51.5608C85.5441 47.191 83.9233 42.192 80.0423 39.7025",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M73.5381 69.6816C77.4054 72.0853 79.6659 74.7791 78.3773 77.7627C77.4905 79.816 75.5556 80.5634 72.9963 80.453",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9951 60.5826C39.1598 56.3349 30.1161 54.1973 27.5456 60.1493C24.9763 66.0982 32.6622 71.2367 42.5495 75.5069C52.3847 79.7546 61.4188 81.9062 63.9907 75.9512C66.5626 69.9962 58.8824 64.8528 48.9951 60.5826Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6634 52.0886C59.1172 54.8759 66.6087 51.9062 69.3973 45.4493C72.1847 38.9955 69.2118 31.5026 62.758 28.7153C56.3042 25.928 48.8114 28.9008 46.0241 35.3546C43.2215 41.7765 46.1546 49.2521 52.5777 52.0516L52.6634 52.0886Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M35.6071 41.1238C31.5942 38.679 29.8914 33.601 31.7973 29.1629C33.6846 24.793 38.435 22.5457 42.9081 23.6642",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M25.5414 48.9517C21.1402 47.7844 17.6294 47.9855 16.3408 50.9691C15.454 53.0225 16.2364 54.9435 18.0715 56.7309",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 9",
    opacity: 0.3,
    cx: 47.3619,
    cy: 91.0829,
    rx: 36.5,
    ry: 5.5,
    transform: "rotate(-4.65085 47.3619 91.0829)",
    fill: "#333333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTeamMembers);
export default __webpack_public_path__ + "static/media/noTeamMembers.75aebae80c40146bf71ee75cad6f7291.svg";
export { ForwardRef as ReactComponent };